<script lang="ts" setup>
import KspBlockItem from '@monolith/legacy/components/my-shop/ksp-block/ksp-block-item.vue';
import { KspContent } from '@monolith/legacy/types/home/home';

defineProps<{ content: KspContent[] }>();
</script>

<template>
  <div
    v-if="content"
    class="ksp-block wrapper"
    data-testid="kspBlockContent"
  >
    <template v-for="(key, index) in content.slice(0, 3)">
      <KspBlockItem
        v-if="key.title && key.description.length > 0"
        :id="index + 1"
        :key="index"
        :title="key.title"
        :description="key.description"
      />
    </template>
  </div>
</template>

<style lang="scss" scoped>
@import '@css/vue-import';

.ksp-block {
  @apply ds-grid ds-gap-x-7 ds-gap-y-4 ds-text-center;
  grid-template-areas:
    'title_1'
    'paragraph_1'
    'title_2'
    'paragraph_2'
    'title_3'
    'paragraph_3';
  @include media-breakpoint-up(md) {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-template-areas:
      'title_1 title_2 title_3'
      'paragraph_1 paragraph_2 paragraph_3';
  }
}
</style>
<style lang="scss">
.ksp-block {
  #title {
    &__1 {
      grid-area: title_1;
    }
    &__2 {
      grid-area: title_2;
    }
    &__3 {
      grid-area: title_3;
    }
  }
  #paragraph {
    &__1 {
      grid-area: paragraph_1;
    }
    &__2 {
      grid-area: paragraph_2;
    }
    &__3 {
      grid-area: paragraph_3;
    }
  }

  &__title {
    @apply ds-text-2xl ds-font-semibold;
  }

  &__paragraph {
    @apply ds-text-base ds-mb-6 ds-max-w-md ds-mx-auto;
    a {
      @apply ds-underline;
    }
  }
}
</style>
